import { render, staticRenderFns } from "./fieldCustomChecklist.vue?vue&type=template&id=48c888e8"
import script from "./fieldCustomChecklist.vue?vue&type=script&lang=js"
export * from "./fieldCustomChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports